/**
 * @generated SignedSource<<4b1d53bcc8df63b65a6f3d085cbaae85>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type reenablePaywallButton_LearnOpportunityV2Fragment$data = {
  readonly id: string;
  readonly structureDefinition: {
    readonly title: string;
  };
  readonly " $fragmentType": "reenablePaywallButton_LearnOpportunityV2Fragment";
};
export type reenablePaywallButton_LearnOpportunityV2Fragment$key = {
  readonly " $data"?: reenablePaywallButton_LearnOpportunityV2Fragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"reenablePaywallButton_LearnOpportunityV2Fragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "reenablePaywallButton_LearnOpportunityV2Fragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "structureDefinition",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "LearnOpportunityV2",
  "abstractKey": null
};

(node as any).hash = "235d92bf400eeb5fe086631db80168b6";

export default node;
